import { Route } from '@angular/router';
import {
  authGuardFn,
  roleGuardFn,
  twoFactorAuthGuardFn,
  unAuthGuardFn,
} from '@lockton-apps/shared/data-access/auth';
import { isAdmin, isBrokerOrHigher } from '@lockton-apps/shared/util/helpers';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivateChild: [authGuardFn],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('@lockton-apps/dashboard/feature/dashboard').then(
            (m) => m.dashboardRoutes
          ),
      },
      {
        path: 'my-account',
        loadChildren: () =>
          import('@lockton-apps/auth/feature/account').then(
            (m) => m.accountRoutes
          ),
      },
      {
        path: 'change-password',
        loadChildren: () =>
          import('@lockton-apps/auth/feature/change-password').then(
            (m) => m.changePasswordRoutes
          ),
      },
      {
        path: 'policies',
        loadChildren: () =>
          import('@lockton-apps/policies/feature/policies-shell').then(
            (m) => m.policiesShellRoutes
          ),
      },
      {
        path: 'contacts',
        loadChildren: () =>
          import('@lockton-apps/contacts/feature/contacts-shell').then(
            (m) => m.contactsShellRoutes
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('@lockton-apps/users/feature/users-shell').then(
            (m) => m.usersShellRoutes
          ),
        data: {
          roleGuardPredicate: isAdmin,
        },
        canActivate: [roleGuardFn],
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('@lockton-apps/clients/feature/clients-shell').then(
            (m) => m.clientsShellRoutes
          ),
        data: {
          roleGuardPredicate: isBrokerOrHigher,
        },
        canActivate: [roleGuardFn],
      },
      {
        path: 'news',
        loadChildren: () =>
          import('@lockton-apps/news/feature/news-shell').then(
            (m) => m.newsShellRoutes
          ),
      },
      {
        path: 'brokers',
        loadChildren: () =>
          import('@lockton-apps/brokers/feature/brokers-shell').then(
            (m) => m.brokersShellRoutes
          ),
        data: {
          roleGuardPredicate: isBrokerOrHigher,
        },
        canActivate: [roleGuardFn],
      },
      {
        path: 'my-lockton-team',
        loadChildren: () =>
          import('@lockton-apps/brokers/feature/my-brokers').then(
            (m) => m.myBrokersRoutes
          ),
      },

    ],
  },
  {
    path: 'create-account',
    loadChildren: () =>
      import('@lockton-apps/auth/feature/create-account').then(
        (m) => m.createAccountRoutes
      ),
    canActivate: [unAuthGuardFn],
  },
  {
    path: 'sign-in',
    loadChildren: () =>
      import('@lockton-apps/auth/feature/login').then((m) => m.loginRoutes),
    canActivate: [unAuthGuardFn],
  },
  {
    path: 'set-password',
    loadChildren: () =>
      import('@lockton-apps/auth/feature/set-password').then(
        (m) => m.setPasswordRoutes
      ),
    canActivate: [unAuthGuardFn],
  },
  {
    path: 'verification',
    canActivate: [twoFactorAuthGuardFn, unAuthGuardFn],
    loadChildren: () =>
      import('@lockton-apps/auth/feature/two-factor-auth').then(
        (m) => m.twoFactorAuthRoutes
      ),
  },
  {
    path: 'account-recovery',
    loadChildren: () =>
      import('@lockton-apps/auth/feature/forgot-password').then(
        (m) => m.forgotPasswordRoutes
      ),
    canActivate: [unAuthGuardFn],
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('@lockton-apps/auth/feature/reset-password').then(
        (m) => m.resetPasswordRoutes
      ),
    canActivate: [unAuthGuardFn],
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('@lockton-apps/general/feature/privacy-notice').then(
        (m) => m.privacyNoticeRoutes
      ),
  },
  {
    path: 'faqs',
    loadChildren: () =>
      import('@lockton-apps/faqs/feature/faqs-shell').then(
        (m) => m.faqsShellRoutes
      ),
  },
  {
    path: 'cookies',
    loadChildren: () =>
      import('@lockton-apps/general/feature/cookies-notice').then(
        (m) => m.cookiesNoticeRoutes
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('@lockton-apps/general/feature/page-not-found').then(
        (m) => m.pageNotFoundRoutes
      ),
  },
];
